'use client';

interface Props {
  projects: Array<{ id: string; name: string }>;
  selectedProject: string;
  onProjectChange: (projectId: string) => void;
}

export default function ProjectSelector({ projects, selectedProject, onProjectChange }: Props) {
  return (
    <div className="flex items-center gap-2">
      <label className="text-gray-400 text-sm whitespace-nowrap">프로젝트:</label>
      <select
        value={selectedProject}
        onChange={(e) => onProjectChange(e.target.value)}
        className="px-3 py-2 bg-gray-800 border border-gray-700 rounded-lg text-white text-sm focus:outline-none focus:border-blue-500"
      >
        {projects.map(p => (
          <option key={p.id} value={p.id}>{p.name}</option>
        ))}
      </select>
    </div>
  );
}
